<communication-block
  [selectIdFromRoute]="courseSelectors.selectIdRouteParam"
  [selectEntityById]="courseSelectors.selectById"
  [availableTemplateTypes]="[templateTypes.BOOKING_MODIFIED]"
  [mergeFieldFilters]="['course', 'booking', 'member']"
  [customParticipationLoader]="loadCourseParticipations"
  [customSelectableMembersLoader]="loadCourseSelectableMembers"
  [courseId]="courseId$ | async"
  [contextBookingId]="contextBookingId$ | async"
  [entityId]="courseId$ | async"
></communication-block>
